import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "../ui/breadcrumb";

/**
 * Consistent heading for every admin screen: breadcrumb trail (always starting at Dashboard),
 * a title, optional description and an actions slot on the right.
 */
const AdminPageHeader = ({ crumbs = [], title, description, eyebrow, actions, children }) => (
  <div className="space-y-4" data-testid="admin-page-header">
    <Breadcrumb data-testid="admin-breadcrumbs">
      <BreadcrumbList className="text-[11px] uppercase tracking-[0.18em]">
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/admin" className="hover:text-primary">Dashboard</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {crumbs.map((c, i) => {
          const last = i === crumbs.length - 1;
          return (
            <React.Fragment key={`${c.label}-${i}`}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {last || !c.to ? (
                  <BreadcrumbPage className="max-w-[220px] truncate text-foreground">{c.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={c.to} className="hover:text-primary">{c.label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>

    <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div className="min-w-0">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="display mt-2 truncate text-4xl uppercase leading-none tracking-wide md:text-5xl" data-testid="admin-page-title">
          {title}
        </h1>
        {description && <p className="mt-2 max-w-2xl text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
    </div>
    {children}
  </div>
);

export default AdminPageHeader;
